module.exports = __webpack_public_path__ + "img/remove-circle.c0e25a0d.svg";